// extracted by mini-css-extract-plugin
export default {"container":"DistributionBars_container__pDVv6"};